module.exports = "<div class=\"header\">\n  <h1>{{number}}. {{title}}</h1>\n</div>\n<div class=\"accordion-content\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-main-container-step/alg-main-container-step.component.html
// module id = ./src/app/components/molecules/alg-main-container-step/alg-main-container-step.component.html
// module chunks = main